<template>
  <section class="about">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>About us</h1>
          <img class="logo" src="https://taktpixel.co.jp/img/logo-dark.svg" width="200" alt="タクトピクセル株式会社ロゴ" />
          <h2>
            タクトピクセル株式会社
            <a href="https://taktpixel.co.jp/" target="_blank"><el-button icon="el-icon-info">企業サイトへ</el-button></a>
          </h2>
          <p>
            深層学習を始めとするAI・機械学習の技術を画像処理に適用し、<br>
            印刷業務をより良い方向に改善するソリューションを開発しています。<br>
            <br>
            <router-link :to="{ name: 'contact' }"><el-button type="info" icon="el-icon-message">お問い合わせ</el-button></router-link>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'about',
  components: {
  },
  mounted() {
    scrollTo(0, 0);
  },
}
</script>

<style scoped lang="scss">
h1 {
  margin-bottom:2rem;
}
h2 {
  margin-bottom: 1.5rem;
}
.logo {
  margin: 10px 20px 10px 10px;
}
section { 
  text-align: left;
  margin: 3rem 0;
}
</style>
